import ROUTE from "@app/navigationApp/routes";
import { ArrowsLeftRight } from "@app/sharedComponents/Icons/Icons";
import { themeColorSet, ThemedPressable, ThemedText, ThemedView } from "@app/theme";

const ElevateHeader = ({accountId,switchLender,navigation}) =>{
    console.log('switchLender',switchLender);
    return(
        <>
            <ThemedView backgroundColor="bg-fill-primary" borderTopWidth={1} borderBottomWidth={1} borderColor="border-primary" py="md" px="lg" alignItems="center" flexDirection="row" justifyContent="space-between">
                <ThemedView flexDirection="row" alignItems="center">
                    <ThemedView width={8} height={36} style={{backgroundColor:'#0071BB'}} borderRadius="2xs"/>
                    <ThemedView ml="sm">
                        <ThemedText variant="b3s" color="text-primary" mb="xs">Switch to {switchLender?.lenderInfo?.lenderName}</ThemedText>
                        <ThemedText variant="b4m" color="text-secondary">Click on switch to go to other loan</ThemedText>
                    </ThemedView>
                </ThemedView>
                <ThemedPressable flexDirection="row" alignItems="center" onPress={()=>{navigation.navigate(ROUTE.ELEVATE_SWITCHING,{accountId,targetCreditId:switchLender?.creditId})}}>
                    <ArrowsLeftRight size={20} color={themeColorSet["text-action-primary"]} />
                    <ThemedText color="text-action-primary" ml="xs">Switch</ThemedText>
                </ThemedPressable>

            </ThemedView>
        </>
    )
}

export default ElevateHeader;